import * as Sentry from "@sentry/vue"
import pkg from '../../package.json'

const win = window

class InitSentrt {
	constructor(Vue, router)  {
		if (!InitSentrt.instance) {
			this.init(Vue, router)
			return
		}
		return InitSentrt.instance
	}

	init(Vue, router) {
		const host = window.location.host

		let env = 'prod'
		if (host.includes('.t.')) {
			env = 'stage'
		} else if (host.includes('.qa.')) {
			env = 'qa'
		}

		// 域名白名单检查函数
		const isAllowedOrigin = () => {
			const allowedOrigins = [
				'https://m.t.hopegoo.com',
				'https://m.hopegoo.com',
			]
			const currentOrigin = window.location.origin
			return allowedOrigins.some(origin => currentOrigin.startsWith(origin))
		}

		const integrations = [
			new Sentry.BrowserTracing({
				routingInstrumentation: Sentry.vueRouterInstrumentation(router),
			})
		]


		Sentry.init({
			Vue,
			environment: env,
			release: `${pkg.name} v${pkg.version}`,
			dsn: 'https://0dd7a0ba2543e3b3aa3006c1bcb8d0a4@rum.17u.cn/354',
			integrations,
			sampleRate: 1,
			tracesSampleRate: 1,
			tracePropagationTargets: [
				'localhost',
				'https://m.t.hopegoo.com/actgateway/',
				'https://m.hopegoo.com/actgateway/',
			],
			replaysSessionSampleRate: 0,
			replaysOnErrorSampleRate: 0,
			// 过滤错误事件，只上报 hopegoo.com 域名
			beforeSend(event, hint) {
				if (!isAllowedOrigin()) {
					return null
				}
				return event
			},
			// 过滤性能追踪事件，只上报 hopegoo.com 域名
			beforeSendTransaction(event, hint) {
				if (!isAllowedOrigin()) {
					return null
				}
				return event
			}
		})

		Sentry.setTag('environment', env)
		Sentry.setTag('paid', win._paid || '--')
		Sentry.setTag('refid', win._refid || '--')
		Sentry.setTag('unionid', win._unionId || '--')
		Sentry.setTag('viewtraceid', win._pageViewApmTraceId || '--')
		Sentry.setTag('viewsessionid', win._pageSessionId || '--')
		Sentry.setTag('ssgOptimize', win._ssgOptimize || '--')
		InitSentrt.instance = this
	}

	setLoadProjectInfoWay(type) {
		if (InitSentrt.curLoadProjectInfoWay) return
		InitSentrt.curLoadProjectInfoWay = type
		Sentry.setTag('loadProjectInfoWay', type)
	}
}

export default InitSentrt
